import alt from 'components/Dispatcher';

class LibraryCreateActions {
  constructor() {
    this.generateActions(
      'resetCreateForm',
      'changeField',
      'changePurpose',
      'changeName',
      'addShareElement',
      'changeShareElementType',
      'changeShareElementId',
      'addCurrentSharedElement',
      'submit',
      'removeShare',
      'changeTag',
      'addCurrentTag',
      'removeTag',
      'editLibrary',
      'deleteLibrary',
      'removeTag',
      'clearTags',
      'clearCurrentChosenTag',
      'changeAndAddCurrentTag',
      'changeAndAddUserTag',
      'clearUnsavedShare'
    );
  }
}

export default alt.createActions(LibraryCreateActions);
